module.exports = __webpack_public_path__ + "fonts/AvenyT-Regular.6cdc4cc6.ttf";